import React, { memo } from 'react';
import type { DateRange } from 'react-day-picker';

import { Input } from '../../../types/Input';
import { DayPicker } from '../DayPicker/DayPicker';
import { CommonProps } from '../types';

type Props = Input<DateRange> & CommonProps;

export const DateRangeInput = memo((props: Props) => {
  return <DayPicker isRange {...props} />;
});
